import React from 'react'

const MenuItem = (props) => {
  const { item, selected = false, onItemSelect } = props

  return (
    <div
      className={`menu_item ${selected ? 'menu-item--selected' : ''}`}
      data-slug={item.slug}
      onClick={() => {
        onItemSelect(item)
      }}
    >
      {item.name}
    </div>
  )
}
export default MenuItem
